export default "__VITE_ASSET__CGLe26PF__"